import { useTranslation } from 'react-i18next'
import SearchActionsBar from '@/widgets/SearchActionsBar'
import LoadMoreSection from '@/widgets/LoadMoreSection'
import CertificationsTable from './components/CertificationsTable'
import useCertificationsData from './hooks/useCertificationsData'

export default function Certifications() {
	const { t } = useTranslation()
	const {
		data: certificationsData,
		loading,
		loadingMore,
		totalCount,
		hasMore,
		handleLoadMore,
		handleSort,
		handleSearchChange,
		handleDelete,
		sortColumn,
		sortDirection,
		searchQuery,
	} = useCertificationsData()

	const buttons = [
		{
			type: 'add',
			to: '/centrumSzkolen/certyfikaty/add',
			label: t('trainingCertifications.list.actions.addNew'),
		},
	]

	return (
		<>
			<SearchActionsBar
				value={searchQuery}
				onChange={handleSearchChange}
				placeholder={t('trainingCertifications.list.searchPlaceholder')}
				buttons={buttons}
			/>

			<CertificationsTable
				certificationsData={certificationsData}
				loading={loading}
				sortColumn={sortColumn}
				sortDirection={sortDirection}
				onSort={handleSort}
				onDelete={handleDelete}
			/>

			<LoadMoreSection
				hasMore={hasMore}
				loadingMore={loadingMore}
				onLoadMore={handleLoadMore}
				dataLength={certificationsData.length}
				totalCount={totalCount}
			/>
		</>
	)
}
